export function slugify(text: string): string {
  return text
    .replace(/İ/g, "i") // Büyük İ harfini küçük i yap (noktasız)
    .replace(/I/g, "i") // Büyük I da küçük i gibi kullanılsın
    .replace(/ç/g, "c")
    .replace(/Ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/Ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/Ö/g, "o")
    .replace(/ö/g, "o")
    .replace(/Ş/g, "s")
    .replace(/ş/g, "s")
    .replace(/Ü/g, "u")
    .replace(/ü/g, "u")
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // Harf, sayı, boşluk dışı karakterleri sil
    .trim()
    .replace(/\s+/g, "-") // Boşlukları tireye çevir
    .replace(/-+/g, "-"); // Birden fazla tireyi teke indir
}
